import { render, staticRenderFns } from "./IconSvgPdf.vue?vue&type=template&id=b661e24a&scoped=true&"
import script from "./IconSvgPdf.vue?vue&type=script&lang=js&"
export * from "./IconSvgPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b661e24a",
  null
  
)

export default component.exports